/**
 * Devuelve las iniciales de un nombre completo (máx 2 letras).
 */
export function initials(fullName: string): string {
  return fullName
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p.charAt(0).toUpperCase())
    .join('');
}

/**
 * Calcula la antigüedad en años a partir de la fecha de ingreso.
 */
export function tenureInYears(hireDate: Date | string): number {
  const date = typeof hireDate === 'string' ? new Date(hireDate) : hireDate;
  const ms = Date.now() - date.getTime();
  return Math.floor(ms / (1000 * 60 * 60 * 24 * 365.25));
}

/**
 * Formatea fechas como "07 abr 2026" en español.
 */
export function formatDateEs(date: Date | string): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toLocaleDateString('es-ES', { day: '2-digit', month: 'short', year: 'numeric' });
}
